export const LOGIN          = 'LOGIN'
export const LOGOUT         = 'LOGOUT'
export const SET_HEADERS    = 'SET_HEADERS'

export const USER_SET_CURRENT       = 'USER_SET_CURRENT'
export const USER_REMOVE_CURRENT    = 'USER_REMOVE_CURRENT'
export const USER_SET_SEARCH_TOKEN  = 'USER_SET_SEARCH_TOKEN'
export const USER_TASK_LIST         = 'USER_TASK_LIST'
export const USER_TILE_LIST         = 'USER_TILE_LIST'

export const PARAM_LIST     = 'PARAM_LIST'
export const SHOW_MENU      = 'SHOW_MENU'
export const HIDE_MENU      = 'HIDE_MENU'
export const TOGGLE_MENU    = 'TOGGLE_MENU'
export const UPDATE_WEEK    = 'UPDATE_WEEK'

export const DASHBOARD_LOAD     = 'DASHBOARD_LOAD'
export const DASHBOARD_CLEAR    = 'DASHBOARD_CLEAR'

export const STUDENT_NEW                = 'STUDENT_NEW'
export const STUDENT_LIST               = 'STUDENT_LIST'
export const STUDENT_LIST_REQUEST       = 'STUDENT_LIST_REQUEST'
export const STUDENT_LIST_CLEAR         = 'STUDENT_LIST_CLEAR'
export const STUDENT_DETAIL             = 'STUDENT_DETAIL'
export const STUDENT_DETAIL_CLEAR       = 'STUDENT_DETAIL_CLEAR'
export const STUDENT_DETAIL_WEEK        = 'STUDENT_DETAIL_WEEK'
export const STUDENT_EVENT_STATE        = 'STUDENT_EVENT_STATE'
export const STUDENT_DETAIL_SET_TOKEN   = 'STUDENT_DETAIL_SET_TOKEN'
export const BULK_STUDENT_LIST_ADD      = 'BULK_STUDENT_LIST_ADD'
export const BULK_STUDENT_LIST_REMOVE   = 'BULK_STUDENT_LIST_REMOVE'
export const BULK_STUDENT_LIST_CLEAR    = 'BULK_STUDENT_LIST_CLEAR'

export const BEACON_UNASSIGNED_LIST = 'BEACON_UNASSIGNED_LIST'

export const REPORT_CLEAR   = 'REPORT_CLEAR'
export const REPORT_LIST    = 'REPORT_LIST'
export const STUDENT_COURSE_REPORT_LIST = 'STUDENT_COURSE_REPORT_LIST'
export const STUDENT_EVENT_REPORT_LIST = 'STUDENT_EVENT_REPORT_LIST'
